import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    title1: {
        id: "intro.rhytname.1.title",
    },
    title3: {
        id: "intro.rhytname.3.title",
    },
    title4: {
        id: "intro.rhytname.4.title",
    },
    description1: {
        id: "intro.rhytname.1.description",
    },
    description3: {
        id: "intro.rhytname.3.description",
    },
    description4: {
        id: "intro.rhytname.4.description",
    },
});

export default messages;
